import React, { useState, createContext, useContext, type ReactNode } from 'react'
import cx from 'classnames'
import { Icon } from '../Icon'
import './style.sass'

type TooltipContextType = {
	visible: boolean
	setVisible: (visible: boolean) => void
}

const TooltipContext = createContext<TooltipContextType>({
	visible: false,
	setVisible: () => {},
})

const Questionmark = () => {
	return (
		<span className='Questionmark'>
			<Icon name='questionmark' width={10} height={18} />
		</span>
	)
}

type TooltipContainerProps = {
	children: ReactNode
	className?: string
	callback?: (visible: boolean) => void
}

export const TooltipContainer = ({ children, className, callback }: TooltipContainerProps) => {
	const [visible, setVisible] = useState(false)

	const cs = cx('TooltipContainer', className)

	const onMouseOver = () => {
		setVisible(true)
		callback && callback(true)
	}

	const onMouseOut = () => {
		setVisible(false)
		callback && callback(false)
	}

	return (
		<TooltipContext.Provider value={{ visible, setVisible }}>
			<div className={cs} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
				{children}
			</div>
		</TooltipContext.Provider>
	)
}

export const Tooltip = ({ children }: { children?: ReactNode }) => {
	return children ? children : <Questionmark />
}

type TooltipContentProps = {
	children: ReactNode
	title: ReactNode
	className?: string
}

export const TooltipContent = ({ children, title, className }: TooltipContentProps) => {
	const tooltipContext = useContext(TooltipContext)

	const cs = cx('TooltipContent', className, { 'TooltipContent--visible': tooltipContext.visible })

	return (
		<div className={cs}>
			<div className='TooltipContent__inner'>
				<h5 className='TooltipContent__title'>{title}</h5>
				{children}
			</div>
		</div>
	)
}
